import { render, staticRenderFns } from "./UserDet.vue?vue&type=template&id=749e1309&"
import script from "./UserDet.vue?vue&type=script&lang=js&"
export * from "./UserDet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserDet.vue"
export default component.exports